<template>
  <div
    v-if="isVisible"
    class="pipeline-status-chips d-flex align-center"
    data-testid="pipeline-status-chips"
  >
    <span
      v-for="(chip, index) in chipsWithIndicators"
      :key="String(chip.key)"
      class="pipeline-status-chips__item"
    >
      <span
        v-if="showDividerBefore(chip)"
        class="pipeline-status-chips__divider"
        aria-hidden="true"
        :data-testid="`pipeline-status-chips__divider--${index}`"
      />
      <v-icon
        v-else-if="index > 0 && separatorMode === 'chevron'"
        class="pipeline-status-chips__separator"
        small
        :data-testid="`pipeline-status-chips__separator--${index}`"
      >
        mdi-chevron-right
      </v-icon>
      <div
        class="pipeline-status-chips__chip"
        :class="{
          'pipeline-status-chips__chip--selected': isChipSelected(chip.key),
          'pipeline-status-chips__chip--dashed': Boolean(chip.dashedBorder),
          'pipeline-status-chips__chip--muted': Boolean(chip.mutedLabel),
        }"
        :aria-selected="isChipSelected(chip.key)"
        role="button"
        tabindex="0"
        :data-testid="chip.testId"
        @click="$emit('select-stage', chip.key)"
        @keydown.enter.prevent="$emit('select-stage', chip.key)"
        @keydown.space.prevent="$emit('select-stage', chip.key)"
      >
        <StatusIndicator
          v-if="chip.statusVariant"
          :variant="chip.statusVariant"
          size="sm"
          class="pipeline-status-chips__status-indicator"
          :data-testid="`${chip.testId}-indicator`"
        />
        <span class="pipeline-status-chips__label">{{ chip.label }}</span>
        <span class="pipeline-status-chips__count">{{ activeSummary[chip.summaryKey] || 0 }}</span>
      </div>
    </span>
  </div>
</template>

<script>
import './PipelineStatusChips.scss';
import StatusIndicator from '@/components/StatusIndicator.vue';
import { PIPELINE_STATUS_CHIPS } from '../../utils/listConstants';
import { TASK_STAGE_STATUS_VARIANT } from '../../utils/constants';

export default {
  name: 'PipelineStatusChips',
  components: {
    StatusIndicator,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    metadata: {
      type: Object,
      default: null,
    },
    selectedTabStage: {
      type: [Number, String],
      default: null,
    },
    activeSummary: {
      type: Object,
      default: () => ({}),
    },
    chips: {
      type: Array,
      default: () => PIPELINE_STATUS_CHIPS,
    },
    statusVariantMap: {
      type: Object,
      default: () => TASK_STAGE_STATUS_VARIANT,
    },
    showWhenEmpty: {
      type: Boolean,
      default: false,
    },
    separatorMode: {
      type: String,
      default: 'chevron',
    },
    dividerBeforeKey: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    isVisible() {
      if (!this.loading) return true;
      if (this.showWhenEmpty) return true;
      return !!(this.metadata && this.metadata._id);
    },
    chipsWithIndicators() {
      return this.chips.map((chip) => ({
        ...chip,
        statusVariant: chip.key != null ? (this.statusVariantMap[chip.key] ?? null) : null,
      }));
    },
  },
  methods: {
    isChipSelected(chipKey) {
      return Object.is(this.selectedTabStage, chipKey);
    },
    showDividerBefore(chip) {
      if (this.separatorMode !== 'divider-before') return false;
      if (this.dividerBeforeKey == null) return false;
      return Object.is(chip.key, this.dividerBeforeKey);
    },
  },
};
</script>
